module.exports = __webpack_public_path__ + "2fe27d9d10cdfccb1baef28a45d5ba90.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Lato-Light.ttf
// module id = 489
// module chunks = 0